import React from 'react'
import AppContext from 'AppContext'
import { env, featureEnabled, hasAccess } from 'components/Helpers'

const Monitoring = () => {
  const token = window.localStorage.getItem('auth-token')
  const { operator, user } = React.useContext(AppContext)

  // We may have to wait for AppContext to be available
  if (!operator.id) {
    return (
      <div className='index monitoring'>
        <p>waiting for operator...</p>
      </div>
    )
  }

  return (
    <div>
      <cl-monitoring
        mountPath={`/operators/${operator.id}/monitor`}
        apiHost={`https://donedone.${env()}.credlock.net`}
        operatorid={operator.id}
        token={token}
      >
        {featureEnabled('locationMonitor', operator.id) && hasAccess(user, 'location_monitor.view_alerts') && (
          // the locations alerting now, from location-monitor; above the access card while only it has alerts
          <cl-location-monitor-alerts
            slot='cards'
            // the same space between the cards whichever comes first
            style={{ display: 'block', margin: 'var(--cl-space-12, 12px) 0' }}
            apiHost={`https://location-monitor.${env()}.credlock.net`}
            operatorId={operator.id}
            token={token}
            settingsPath={hasAccess(user, 'location_monitor.view_settings') ? `/operators/${operator.id}/location-monitor` : undefined}
          />
        )}
      </cl-monitoring>
    </div>
  )
}

const MonitoringWrapper = ({ permission, history }) => {
  return (
    <div className='monitoring-wrapper'>
      <Monitoring />
    </div>
  )
}

export default MonitoringWrapper
